import { NavLink } from 'react-router-dom';

const Footer = () => {
    return (
        <div className="footer">
            <div className="d_1">
                <div className="logo-container">
                    <div className="img-container"><img src="/assets/footer/logo.svg" alt="footer" /></div>
                    <div style={{fontSize: "15px", fontWeight: 300, lineHeight: '135%', color: '#FFFFFF'}}>*Pfizer reserves the right, in its sole discretion, to decline admittance to or remove individuals from the platform at any time.</div>
                </div>
                <div className="routes">
                    <NavLink target="_blank" rel="noreferrer" to="/">Home</NavLink>
                    {/* <Link to="/sitemap">Sitemap</Link> */}
                    <NavLink target="_blank" rel="noreferrer" to="https://www.almaconnect.com/privacy-center?tab=Privacy%20Policy">Privacy</NavLink>
                </div>
            </div>
        </div>
    );
};
export default Footer;